import axios from '../config/axios';
const PATH = '/pedidos';

export default {
	async create(body) {
		const response = await axios().post(PATH, body);
		return response.data;
	},
	async find(page = 1, params) {
		const response = await axios().get(PATH, {
			params: {
				page,
				...params
			}
		});
		return response.data;
	},
	async update(id, body) {
		const response = await axios().put(`${PATH}/${id}`, body);
		return response.data;
	},
	async remove(id) {
		const response = await axios().delete(`${PATH}/${id}`);
		return response.data;
	},
	async sincronizar(id) {
		const response = await axios().post(`${PATH}/${id}/sincronizar`);
		return response.data;
	},
	async emitirBoleto(id, vencimento, cpf_cnpj, usuario) {
		const response = await axios().post(`${PATH}/${id}/emitirBoleto`, {
			id,
			vencimento,
			cpf_cnpj,
			usuario
		});
		return response.data;
	}
};